export default __webpack_public_path__ + "static/media/Captain bee.a6bd348d.svg";